export default {
  title: "WinIt - Fight Parking & Traffic Tickets",
  description:
    "WinIt helps you manage and dispute your parking and traffic tickets efficiently. Join over 700,000 users today!",
  openGraph: {
    type: "website",
    locale: "en_US",
    site_name: "WinIt",
  },
  twitter: {
    handle: "@WinIt_App",
    site: "@WinIt_App",
    cardType: "summary_large_image",
  },
  facebook: process.env.FACEBOOK_APP_ID
    ? {
        appId: process.env.FACEBOOK_APP_ID,
      }
    : undefined,
  additionalMetaTags: [
    {
      name: "apple-itunes-app",
      content: "app-id=929918279",
    },
  ],
}
